// Implemented and adjusted according to: https://stackoverflow.com/questions/4770025/how-to-disable-scrolling-tempor
const KEYS = { 37: 1, 38: 1, 39: 1, 40: 1 };

export default class Scrolling {
  constructor(wrapper) {
    this.wrapper = wrapper;

    // modern Chrome requires { passive: false } when adding event
    let supportsPassive = false;
    try {
      window.addEventListener(
        'test',
        null,
        Object.defineProperty({}, 'passive', {
          get: function () {
            supportsPassive = true;
          },
        }),
      );
    } catch (e) {}

    this.wheelOpt = supportsPassive ? { passive: false } : false;
    this.wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';
    this.isEnabled = true;

    this._preventDefaultCallback = this._preventDefault.bind(this);
    this._preventDefaultForScrollKeysCallback = this._preventDefaultForScrollKeys.bind(this);
  }

  disable() {
    window.addEventListener('DOMMouseScroll', this._preventDefaultCallback, false); // older FF
    window.addEventListener(this.wheelEvent, this._preventDefaultCallback, this.wheelOpt); // modern desktop
    window.addEventListener('touchmove', this._preventDefaultCallback, this.wheelOpt); // mobile
    window.addEventListener('keydown', this._preventDefaultForScrollKeysCallback, false);

    this.isEnabled = false;
  }

  enable() {
    window.removeEventListener('DOMMouseScroll', this._preventDefaultCallback, false);
    window.removeEventListener(this.wheelEvent, this._preventDefaultCallback, this.wheelOpt);
    window.removeEventListener('touchmove', this._preventDefaultCallback, this.wheelOpt);
    window.removeEventListener('keydown', this._preventDefaultForScrollKeysCallback, false);

    this.isEnabled = true;
  }

  _preventDefaultForScrollKeys(e) {
    if (this.wrapper.contains(e.target)) return;

    if (KEYS[e.keyCode]) {
      this._preventDefault(e);

      return false;
    }
  }

  _preventDefault(e) {
    if (this.wrapper.contains(e.target)) return;

    e.preventDefault();
  }
}
